import * as React from "react";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import { Box } from "@mui/material";
import FormLabel from "@/Components/Form/FormLabel"; // Ensure it supports 'required' & 'gap'

// Custom styled toggle (same as your image)
const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 42,
  height: 22,
  padding: 0,
  display: "flex",
  "&:active .MuiSwitch-thumb": {
    width: 22,
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(20px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#2E0F6D", // ✅ Purple when ON
        opacity: 1,
        border: 0,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 0 0 / 20%)",
    width: 18,
    height: 18,
    borderRadius: "50%",
    backgroundColor: "#fff",
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    opacity: 1,
    backgroundColor: "#E0E0E0", // ✅ Gray when OFF
    boxSizing: "border-box",
  },
}));

export default function ToggleButton({
  label,
  value,
  onChange,
  disabled,
  gap = 0,
  required = false,
}) {
  return (
    <Box
      display="flex"
      flexDirection="column"   // ✅ label on top, toggle below
      alignItems="flex-start"  // ✅ align neatly on left
      gap={0.5}                // ✅ small space between label and switch
    >
      {label && (
        <FormLabel label={label} gap={gap} required={required} />
      )}
      <CustomSwitch
        checked={Boolean(value)}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
    </Box>
  );
}
